import React, { useState } from 'react';
import { ArrowUpRight, Sparkles } from 'lucide-react';
import { Link } from 'react-router-dom';
import AuditModal from './AuditModal';

const CTABanner = ({
  eyebrow = 'Ready when you are',
  title = 'Ready to scale your email revenue?',
  body = 'Book a 30-minute strategy call. We will look at your funnel, your data, and your numbers — and leave you with three actions you can ship this week.',
}) => {
  const [open, setOpen] = useState(false);
  return (
    <section className="container-x section" data-testid="cta-banner">
      <div className="relative overflow-hidden rounded-[2rem] bg-[var(--gh-orange)] text-[var(--gh-cream)]">
        {/* Decorative grid lines */}
        <div
          aria-hidden
          className="absolute inset-0 opacity-[0.12]"
          style={{
            backgroundImage:
              'linear-gradient(rgba(255,255,255,.6) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,.6) 1px, transparent 1px)',
            backgroundSize: '48px 48px',
          }}
        />
        {/* Decorative blobs */}
        <div aria-hidden className="absolute -top-20 -right-16 w-64 h-64 rounded-full bg-white/15 blur-3xl" />
        <div aria-hidden className="absolute -bottom-24 -left-10 w-72 h-72 rounded-full bg-black/15 blur-3xl" />

        <div className="relative grid lg:grid-cols-12 gap-10 p-10 md:p-16 items-center">
          <div className="lg:col-span-7">
            <span className="inline-flex items-center gap-2 bg-white/15 backdrop-blur px-3 py-1 rounded-full text-xs font-semibold uppercase tracking-[0.2em]">
              <Sparkles className="w-3.5 h-3.5" /> {eyebrow}
            </span>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-extrabold mt-6 leading-[1.05]">
              {title}
            </h2>
            <p className="mt-5 text-base md:text-lg text-white/85 max-w-xl leading-relaxed">
              {body}
            </p>
            <div className="mt-8 flex flex-col sm:flex-row gap-3">
              <button
                onClick={() => setOpen(true)}
                data-testid="cta-banner-audit-btn"
                className="bg-[var(--gh-ink)] text-[var(--gh-cream)] hover:bg-black rounded-full px-7 py-3.5 font-semibold inline-flex items-center gap-2 transition-colors"
              >
                Get a free audit <ArrowUpRight className="w-4 h-4" />
              </button>
              <Link
                to="/contact"
                data-testid="cta-banner-contact-link"
                className="bg-white text-[var(--gh-ink)] hover:bg-white/90 rounded-full px-7 py-3.5 font-semibold inline-flex items-center gap-2 transition-colors"
              >
                Send a brief
              </Link>
            </div>
          </div>

          <div className="lg:col-span-5 relative">
            <div className="aspect-[4/5] rounded-[1.5rem] overflow-hidden ring-4 ring-white/40 shadow-2xl">
              <img
                src="https://customer-assets.emergentagent.com/job_29705e5f-423b-4b0e-b0e1-cd61c1bb3398/artifacts/a8ldnndg_Screenshot%202025-12-11%20at%205.52.30%E2%80%AFPM.png"
                alt="Akash Tiwari, Growth Hacking founder"
                className="w-full h-full object-cover"
                onError={(e) => {
                  e.currentTarget.src =
                    'https://images.unsplash.com/photo-1649433658557-54cf58577c68?w=900&q=80';
                }}
              />
            </div>
            <div className="absolute -bottom-4 -left-4 float-card px-4 py-3 text-[var(--gh-ink)] hidden sm:block">
              <p className="text-[10px] uppercase tracking-widest text-muted-warm">Replies in</p>
              <p className="text-lg font-bold">&lt; 24 hours</p>
            </div>
          </div>
        </div>
      </div>
      <AuditModal isOpen={open} onClose={() => setOpen(false)} />
    </section>
  );
};

export default CTABanner;
